import React from 'react';
import { Tag, Tooltip, Typography } from 'antd';

import type { InspectAssessmentNews } from '../../../../state/app/inspect_assessment/types';
import type { IcsDescription } from './ics';
import type { InspectAssessmentUserSelection } from './userAssignments';

export type InspectAssessmentNewsDisplayRow = {
  news: InspectAssessmentNews;
  ics: IcsDescription;
  userSelection: InspectAssessmentUserSelection;
};

type UserNewsItemProps = {
  instrumentCode?: string;
  row: InspectAssessmentNewsDisplayRow;
  selectionStyle?: 'highlight' | 'incorrect';
  sourcePeriodIndex: number;
};

const UserNewsItem: React.FC<UserNewsItemProps> = ({
  instrumentCode,
  row: { news, ics, userSelection },
  selectionStyle,
  sourcePeriodIndex,
}) => {
  const classes = ['assessment-inspect-assessment__news-item'];
  if (userSelection.selected && selectionStyle) {
    classes.push(`assessment-inspect-assessment__news-item--${selectionStyle}`);
  }

  return (
    <article className={classes.join(' ')}>
      <Typography.Text className="assessment-inspect-assessment__news-headline">
        {news.headline}
      </Typography.Text>
      <span className="assessment-inspect-assessment__news-item-meta">
        {selectionStyle &&
          userSelection.latePeriodIndices.map(periodIndex => (
            <Tooltip
              key={periodIndex}
              title={`This news appeared in P${sourcePeriodIndex}; the user linked it to ${
                instrumentCode ?? 'the selected instrument'
              } during P${periodIndex}.`}
            >
              <Tag
                className="assessment-inspect-assessment__late-tag"
                color="gold"
                tabIndex={0}
              >
                Late (P{periodIndex})
              </Tag>
            </Tooltip>
          ))}
        <span
          className={`assessment-inspect-assessment__news-ics assessment-inspect-assessment__news-ics--${ics.tone}`}
        >
          {ics.text}
        </span>
      </span>
    </article>
  );
};

export default UserNewsItem;
